/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  XAICurveMagicianETH,
  XAICurveMagicianETHInterface,
} from "../XAICurveMagicianETH";

const _abi = [
  {
    inputs: [],
    name: "InvalidAsset",
    type: "error",
  },
  {
    inputs: [],
    name: "CRV3_POOL",
    outputs: [
      {
        internalType: "contract ICurvePoolLike128",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ONE_USDC",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ONE_USDT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ONE_WETH",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TRICRYPTO2_POOL",
    outputs: [
      {
        internalType: "contract ICurvePoolLike256",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UNKNOWN_MIN_DY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDC",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDC_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDC_INDEX_3CRV",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDC_INDEX_XAIPOOL",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDT",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDT_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDT_INDEX_3CRV",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDT_INDEX_TRICRYPTO",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WETH_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WETH_INDEX_TRICRYPTO",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "XAI",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "XAI_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "XAI_FRAXBP_POOL",
    outputs: [
      {
        internalType: "contract ICurveMetaPoolLike",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "XAI_INDEX_XAIPOOL",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsAsset",
    outputs: [
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsNative",
    outputs: [
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type XAICurveMagicianETHConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: XAICurveMagicianETHConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class XAICurveMagicianETH__factory extends ContractFactory {
  constructor(...args: XAICurveMagicianETHConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "XAICurveMagicianETH";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<XAICurveMagicianETH> {
    return super.deploy(overrides || {}) as Promise<XAICurveMagicianETH>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): XAICurveMagicianETH {
    return super.attach(address) as XAICurveMagicianETH;
  }
  connect(signer: Signer): XAICurveMagicianETH__factory {
    return super.connect(signer) as XAICurveMagicianETH__factory;
  }
  static readonly contractName: "XAICurveMagicianETH";
  public readonly contractName: "XAICurveMagicianETH";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): XAICurveMagicianETHInterface {
    return new utils.Interface(_abi) as XAICurveMagicianETHInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): XAICurveMagicianETH {
    return new Contract(address, _abi, signerOrProvider) as XAICurveMagicianETH;
  }
}
